function classNames(...classes: string[]): string {
	return classes
		.filter((className) => !!className)
		.join(' ');
}

export {classNames};